<template>
	<!-- <nav v-if="!!(bot.style && bot.style.header)" class="Header custom" v-html="bot.style.header"></nav> -->
	<nav class="Header">
		<div class="header-area">
			<Thumb />
			<h2>{{ name }}</h2>
		</div>
		<div v-if="topMenus" class="menus">
			<A v-for="menu in topMenus" :key="`menu_${menu.id}`" @click="onClickMenu(menu)">
				<span>{{ menu.label }}</span>
				<div class="nested" v-if="menu.type === 'nested'">
					<A v-for="btn in menu.btns" :key="`btn_${btn.id}`" @click="onClickMenu(btn)">{{ btn.label }}</A>
				</div>
			</A>
		</div>
	</nav>
</template>

<script>
	import { mapState } from 'vuex';
	import Thumb from './Thumb';
	import whevent from 'whevent';
	export default {
		components: {
			Thumb
		},
		computed: {
			...mapState(['bot', 'name']),
			topMenus() {
				return this.bot.rmenus?.sdk?.[0]?.btns ?? [];
			}
		},

		methods: {
			onClickMenu(menu) {
				if (menu.type === 'act') {
					whevent.emit('ACTION', menu);
				} else if (menu.type === 'url') {
					whevent.emit('ACTION', menu);
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.Header {
		&:not(.custom) {
			background-color: var(--clrTheme);
			color: white;
			padding: 1rem 1.6rem;

			.header-area {
				display: flex;
				align-items: center;

				/deep/ .Thumb {
					width: 3rem;
					height: 3rem;
				}

				h2 {
					font-size: 1em;
				}
			}

			.menus {
				display: flex;
				align-items: center;
				margin: 0 -1rem;

				&:not(:empty) {
					margin-top: 1rem;
				}

				.A {
					padding: 0.5rem 1rem;
					border-radius: 0.5rem;
					font-size: 1.4rem;
					white-space: nowrap;

					@media only screen and (max-width: 460px) {
						font-size: 1.2rem;
					}
					&:hover {
						background-color: rgba(255, 255, 255, 0.1);
					}
				}

				& > * {
					position: relative;
					&:not(:first-child) {
						margin-left: 0.5rem;
					}

					&:hover,
					&:active,
					&:focus {
						.nested {
							pointer-events: all;
							opacity: 1;
						}
					}

					.nested {
						transition: all 0.3s;
						pointer-events: none;
						position: absolute;
						display: flex;
						flex-direction: column;
						justify-content: stretch;
						z-index: 1;
						opacity: 0;
						background-color: var(--clrTheme);
						border-radius: 0.5rem;
						border: solid 1px rgba(0, 0, 0, 0.1);
						box-shadow: 0px 0px 0.5rem rgba(0, 0, 0, 0.5);
					}
				}
			}
		}
	}
</style>
